import { render, staticRenderFns } from "./business-info-form-dialog.vue?vue&type=template&id=21b5f57a"
import script from "./business-info-form-dialog.vue?vue&type=script&lang=js"
export * from "./business-info-form-dialog.vue?vue&type=script&lang=js"
import style0 from "./business-info-form-dialog.vue?vue&type=style&index=0&id=21b5f57a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports